<div *ngIf="imp.isImpersonating" class="nio-impersonation-banner">
  <div class="msg">
    <mat-icon>person</mat-icon>
    <b>You are impersonating:</b>
    {{ imp.ctx.customerName || "Customer" }} (CID: {{ imp.ctx.cid }})
    <small> · since {{ imp.ctx.startedAt | date : "shortTime" }}</small>
  </div>
  <button class="release-btn" mat-stroked-button (click)="imp.release()">
    Release
  </button>
</div>
